var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckboxChecked = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 21,
  height: 21,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#005E09",
  d: "M0 4a4 4 0 0 1 4-4h13a4 4 0 0 1 4 4v13a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#F2F4F2",
  d: "M13.84 7.174a.503.503 0 0 0-.162-.129.434.434 0 0 0-.384 0 .502.502 0 0 0-.162.129l-3.71 4.379-1.56-1.844a.508.508 0 0 0-.166-.126.441.441 0 0 0-.39.008.517.517 0 0 0-.163.133.62.62 0 0 0-.108.197.696.696 0 0 0 .007.459.612.612 0 0 0 .113.192l1.913 2.254a.502.502 0 0 0 .162.129.434.434 0 0 0 .383 0 .503.503 0 0 0 .162-.129l4.065-4.79a.596.596 0 0 0 .118-.195.678.678 0 0 0 0-.471.596.596 0 0 0-.118-.196Z"
})));
export default SvgCheckboxChecked;